import React from 'react';
import Combobox from '@ls/react-combobox-grid';
import currencyCodes from 'state/selections/CurrencyCodes'
import {ccColumnDef} from 'state/selections/CurrencyCodes'
import { useDispatch, useSelector } from 'react-redux';
import { setLocalCurrencyFilter } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';

import {
  selectSelectedLocalCurrencyFiltervalues
} from 'state/selections/selectors';

const LocalCurrencyFilterSelector = props => {
const dispatch = useDispatch();
const values = useSelector(
  selectSelectedLocalCurrencyFiltervalues(SelectionState.UNCOMMITTED)
);

const options = currencyCodes;
const onChange = React.useCallback(
  currencyCodes => {
    dispatch(setLocalCurrencyFilter(currencyCodes));
  },
  [dispatch]
);
return (
    <Combobox
      placeholder="Currency Codes..."
      options={options}
      onChange={onChange}
      value={values}
      label={"Local Currency Codes"}
     // loading={loading}
      valueKey="currencyCode"
      labelKey="currencyCode"
      columnDefs={ccColumnDef}
      variation={1}
      multi
    />
    
  );
}

export default LocalCurrencyFilterSelector
